module.exports = __webpack_public_path__ + "static/GorditaMedium-d3f0718ba1d8c3c8cfb6d37d70dbe8df.woff";